export enum GenericField {
    _static = "Static Value",
    row_number = "Number of Row",
}

export enum UserField {
    username = "NetID",
    email = "Email",
    student_id = "RUID",
    display_name = "Full Name",
    nickname = "Nickname",
    given_name = "First Name",
    family_name = "Last Name",
    birthdate = "Birthdate",
    school_code = "College Code",
    pronouns = "Pronouns",
    admitcode = "Curr_Admit_Type_Cd",
}

export enum ExamField {
    final_score = "Final Score",
    available_score = "Available Score",
    start_time = "Start Time",
    finish_time = "Finish Time",
    started_late = "Started Late",
    finished_late = "Finished Late",
    comments = "Comments"
}

export enum PartField {
    part_score = "Part Score",
    available_score = "Available Score",
    start_time = "Start Time",
    answer_time = "Answer Time",
    spent_time = "Spent Time"
}

export enum QuestionField {
    correctness = "Correctness",
    points_earned = "Points Earned",
    seconds_spent = "Seconds Spent",
    firstseen = "First Seen",
    lasttouched = "Last Touched",
    response = "Response"
}

export enum PartSelector {
    exampart_id = "Exam Part ID",
    part_position = "Part Position"
}

export enum QuestionSelector {
    examquestion_id = "Exam Question ID",
    question_position = "Question Position"
}

export enum PartDifferentiator {
    first = "First",
    last = "Last",
    best_part_score = "Best Part Score"
}

export enum QuestionDifferentiator {
    first = "First",
    last = "Last",
    best_part_score = "Best Part Score",
    best_question_correctness = "Best Question Correctness"
}
